(function () {
  function init(el) {
    const items = el.querySelectorAll('.text-switcher__item');
    if (items.length <= 1) return;

    const interval = parseInt(el.dataset.interval, 10) || 1000;
    const pauseOnHover = el.dataset.pauseOnHover === 'true';

    let idx = 0;
    let timer = null;
    let paused = false;

    function step() {
      const cur = items[idx];
      idx = (idx + 1) % items.length;
      const next = items[idx];

      cur.classList.remove('is-active');
      cur.classList.add('is-leaving');
      next.classList.add('is-active');

      window.setTimeout(function () {
        cur.classList.remove('is-leaving');
      }, 500);
    }

    function start() {
      stop();
      timer = window.setInterval(function () {
        if (!paused) step();
      }, interval);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    if (pauseOnHover) {
      el.addEventListener('mouseenter', function () { paused = true; });
      el.addEventListener('mouseleave', function () { paused = false; });
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    start();
  }

  function initAll() {
    document.querySelectorAll('.text-switcher').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init on theme editor block changes
  document.addEventListener('shopify:section:load', initAll);
})();